import type { SidebarPages } from "../../environments/sidebar-pages";

/** Related pages follow the owning sidebar page; shared viewers stay independent. */
const pageOwners: Record<string, keyof SidebarPages> = {
  "flow-briefing-auto": "flow-briefing",
  "flow-briefing-documents": "flow-briefing",
  "flow-briefing-notams": "flow-briefing",
  "flow-briefing-weather": "flow-briefing",
  "flow-briefing-webcams": "flow-briefing",
  "updates-detail": "updates",
  "add-edit-flightrecord": "flight-timer-list",
};

export function isPageEnabled(pages: SidebarPages, url: string): boolean {
  const path = url.replace(/^\//, "").split(/[/?#]/)[0];
  const owner = pageOwners[path] ?? path;
  return pages[owner as keyof SidebarPages] !== false;
}
